export default __webpack_public_path__ + "static/media/promo-spectrespecs_01.86d62aa9.jpg";